import { useCurrentUser } from '@axilon-apps/domains-identity/state'
import { isIdentityEnabled } from '@axilon-apps/domains-ontology-ui-state'

/**
 * Name stamped on work-order completions & comments.
 * Identity on → current user's display name (fallback `unknown`).
 * Identity off → always `unknown`.
 */
export function useTechnicianName(): string {
  const currentUser = useCurrentUser()
  if (!isIdentityEnabled()) return 'unknown'
  const name = typeof currentUser?.name === 'string' ? currentUser.name.trim() : ''
  return name.length > 0 ? name : 'unknown'
}
